var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilyhover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 318,
    viewBox: "0 0 318 318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_561",
    x: 0,
    y: 0,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_15_1",
    "data-name": "Component 15 \\u2013 1",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_561-2",
    "data-name": "Rectangle 561",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 293,
    height: 293,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Family",
    transform: "translate(150 279.1)",
    fill: "#099",
    fontSize: 48,
    fontFamily: "MyriadPro-Semibold, Myriad Pro",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -68.064,
    y: 0
  }, "Family")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 100,
    cy: 100,
    r: 100,
    transform: "translate(50 25.1)",
    fill: "#099"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "translate(72.648 31.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889",
    transform: "translate(31.319 51.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M22.066,29.733a11.3,11.3,0,1,0-11.3-11.3A11.314,11.314,0,0,0,22.066,29.733Zm0-18.869A7.567,7.567,0,1,1,14.5,18.432,7.576,7.576,0,0,1,22.066,10.864Z",
    transform: "translate(-6.32 -7.13)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M4.867,115.653v33.633a1.867,1.867,0,1,0,3.734,0V114.692c0-.028,0-.057,0-.085a1.867,1.867,0,0,0-.989-1.658,7.27,7.27,0,0,1-3.873-6.421V86A7.272,7.272,0,0,1,11,78.735h9.571A7.273,7.273,0,0,1,27.833,86v20.527a7.271,7.271,0,0,1-3.875,6.421,1.865,1.865,0,0,0-.988,1.7c0,.015,0,.03,0,.045v34.595a1.867,1.867,0,1,0,3.734,0V115.65a10.986,10.986,0,0,0,4.865-9.123V86a11.012,11.012,0,0,0-11-11H11A11.013,11.013,0,0,0,0,86v20.527A10.985,10.985,0,0,0,4.867,115.653Z",
    transform: "translate(0 -46.978)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M108.709,91.523a11.3,11.3,0,1,0-11.3-11.3A11.316,11.316,0,0,0,108.709,91.523Zm0-18.871a7.568,7.568,0,1,1-7.566,7.568A7.577,7.577,0,0,1,108.709,72.651Z",
    transform: "translate(-57.191 -43.407)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M98.637,167.629v17.935a1.867,1.867,0,1,0,3.734,0v-18.9c0-.029,0-.057,0-.085a1.866,1.866,0,0,0-.988-1.658A7.272,7.272,0,0,1,97.5,158.5V147.788a7.273,7.273,0,0,1,7.264-7.265h3.685a7.272,7.272,0,0,1,7.264,7.265V158.5a7.275,7.275,0,0,1-3.875,6.422,1.866,1.866,0,0,0-.987,1.7c0,.015,0,.029,0,.045v18.9a1.867,1.867,0,0,0,3.735,0V167.626a10.99,10.99,0,0,0,4.864-9.123V147.788a11.011,11.011,0,0,0-11-11h-3.685a11.011,11.011,0,0,0-11,11V158.5A10.987,10.987,0,0,0,98.637,167.629Z",
    transform: "translate(-55.055 -83.256)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M200.3,43.99a11.3,11.3,0,1,0-11.3-11.3A11.313,11.313,0,0,0,200.3,43.99Zm0-18.871a7.568,7.568,0,1,1-7.568,7.571A7.578,7.578,0,0,1,200.3,25.118Z",
    transform: "translate(-110.962 -15.499)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M168.021,130.725h10.928v26.934a1.867,1.867,0,0,0,3.735,0v-28.8a1.881,1.881,0,0,0-.038-.377,1.819,1.819,0,0,0-.046-.179,1.868,1.868,0,0,0-1.783-1.312h-9.774l8.462-16.925a1.866,1.866,0,0,0,.2-.835v-9.053a7.184,7.184,0,0,1,14.368,0v9.053a1.864,1.864,0,0,0,.2.835l8.462,16.925h-9.7a1.868,1.868,0,0,0-1.783,1.312c-.018.059-.033.118-.046.179a1.854,1.854,0,0,0-.038.377v28.8a1.867,1.867,0,1,0,3.734,0V130.725H205.75a1.867,1.867,0,0,0,1.67-2.7L197.8,108.789v-8.612a10.918,10.918,0,0,0-21.837,0v8.612l-9.616,19.234a1.867,1.867,0,0,0,1.669,2.7Z",
    transform: "translate(-97.553 -55.351)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyhover);
export default __webpack_public_path__ + "static/media/familyhover.e6f712872a8a86a095aff0ead106f534.svg";
export { ForwardRef as ReactComponent };